var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.001,
    height: 24.001,
    viewBox: "0 0 24.001 24.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,2.25v24H24v-24ZM19.94,7.934,18.654,9.166a.378.378,0,0,0-.145.359V18.6a.369.369,0,0,0,.145.359l1.259,1.232v.273H13.592V20.2l1.3-1.264c.129-.129.129-.166.129-.359V11.24L11.4,20.433h-.488L6.7,11.24V17.4a.847.847,0,0,0,.236.707L8.625,20.16v.273H3.814V20.16l1.693-2.052a.82.82,0,0,0,.22-.707V10.275a.612.612,0,0,0-.2-.525L4.018,7.934V7.661H8.695l3.611,7.929,3.177-7.924H19.94Z",
    transform: "translate(0 -2.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.ad1feb641532f2fdba2e957c68a4e283.svg";
export { ForwardRef as ReactComponent };